// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__9XUzk","content":"RecentSearches_content__NzmST"};